import {
  Component,
  ElementRef,
  Renderer2,
  OnInit,
  AfterViewInit,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { WrapperComponent } from '../../../../wrapper/wrapper.component';
import { FilterToolComponent } from '../../../../../global/filter-tool/filter-tool.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogueComponent } from '@/app/components/global/dialog-boxes/confirmation-dialogue/confirmation-dialogue.component';
import { ModalConfigratoinData } from '@/app/components/global/modal-configration-data.json';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { MatMenuModule } from '@angular/material/menu';
@Component({
  selector: 'app-eoi-history',
  standalone: true,
  imports: [
    MatIcon,
    CommonModule,
    WrapperComponent,
    FilterToolComponent,
    MatMenuModule,
  ],
  templateUrl: './eoi-history.component.html',
  styleUrl: './eoi-history.component.css',
})
export class EoiHistoryComponent implements OnInit, AfterViewInit {
  isCreate = false;
  currentDialog = 'EOI';
  eoi_confirmation_dialog_data =
    ModalConfigratoinData.EOi_Confirmation_Dialog_Data;
  activeRowIndex: number | null = null;
  savedEOIData: any = [];
  tableData!: any;
  projectId: any;
  projectIdNew: any;
  projectName: string;
  projectIdentifier: string;
  private subscription: Subscription = new Subscription();

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private projectsService: ProjectsService,
    private getProjectIdService: GetProjectIdService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private tenderingService: TenderingService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });

    this.projectId = this.getProjectIdService.getProjectId();
    this.tableData = this.getEoiHistory();
    this.getEoiHistory();
    this.subscription = this.getProjectIdService.projectId$.subscribe((id) => {
      this.projectIdNew = id;
      if (!this.projectIdNew) {
        this.projectIdNew = this.getProjectIdService.getProjectId();
      }
      this.getEoiHistory();
    });
  }

  getEoiHistory(): any {
    return this.tenderingService.getEoiList(this.projectId).subscribe({
      next: (data: any) => {
        this.tableData = data.data;
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }

  formatDate(dateString: string): string | null {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero
    const day = ('0' + date.getDate()).slice(-2); // Add leading zero

    return `${year}-${month}-${day}`;
  }

  openView(id: any) {
    localStorage.setItem('eoi_id', id);
    this.router.navigate(['/initiate-eoi', this.projectId, id], {
      queryParams: { projectName: this.projectName, projectIdentifier: this.projectIdentifier },
    });
  }

  handleCreateEoi() {
    this.isCreate = true;
    // NOTE: reset saved data to empty array on create event
    this.savedEOIData = [];
    this.tenderingService.setProjectIdentifier(this.projectIdentifier);
  }

  closeEoiSubmissions(eoi_id: any) {
    return this.projectsService.closeEOI(eoi_id).subscribe({
      next: (data: any) => {
        if (data) {
          this.getEoiHistory();
        }
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }
  ngAfterViewInit() {
    // Detect clicks outside the component after view initialization
    this.renderer.listen('document', 'click', (event: MouseEvent) =>
      this.onDocumentClick(event)
    );
  }
  setActiveRow(index: number): void {
    this.activeRowIndex = this.activeRowIndex === index ? null : index;
    // Toggle logic
  }
  // Check if the click is outside the target element (clickable area)
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.activeRowIndex = null; // Close the active row if click is outside
    }
  }
  confirmationDialog(eoi_id: any) {
    // Opens the dialog
    const dialogRef = this.dialog.open(ConfirmationDialogueComponent, {
      width: '30.313rem',
      height: '15.75rem',
      autoFocus: false,
      data: {
        ...this.eoi_confirmation_dialog_data,
        eoi_id: eoi_id,
      },
    });
    dialogRef.afterClosed().subscribe(() => {
      this.activeRowIndex = null; // Reset activeRowIndex to null
    });
  }
  handleDialog() {
    this.isCreate = false;
    this.getEoiHistory();
  }

  resumeEOIDialogue(selectedEoiId) {
    this.tenderingService.setProjectIdentifier(this.projectIdentifier);
    this.tenderingService
      .getEOICurrentStageData(this.projectId, selectedEoiId)
      .subscribe({
        next: (response: any) => {
          if (response?.data) {
            this.savedEOIData = response.data;
            this.isCreate = true;
          }
        },
        error: (error: any) => {
          console.error('Failed to fetch:', error);
        },
      });
  }
}
